import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for updating a marker
 */
export interface UpdateMarkerVariables {
  markerId: string;
  markIn?: string;
  markOut?: string;
  markInSeconds?: number;
  markOutSeconds?: number;
  title?: string;
  description?: string;
}

/**
 * Updated marker structure
 */
export interface UpdatedMarker {
  markerId: string;
  title: string | null;
  description: string | null;
  markIn: string;
  markOut: string | null;
}

/**
 * Update marker mutation response payload
 */
export interface UpdateMarkerPayload {
  __typename: string;
  marker: UpdatedMarker;
}

/**
 * Response structure for updateMarker mutation
 */
export interface UpdateMarkerResponse {
  updateMarker: UpdateMarkerPayload;
}

const updateMarker: DocumentNode = gql`
  mutation updateMarker(
    $markerId: ID!,
    $markIn: String,
    $markOut: String,
    $markInSeconds: Float,
    $markOutSeconds: Float,
    $title: String,
    $description: String
  ) {
    updateMarker(
      markerId: $markerId,
      markIn: $markIn,
      markOut: $markOut,
      markInSeconds: $markInSeconds,
      markOutSeconds: $markOutSeconds,
      title: $title,
      description: $description
    ) {
      __typename
      marker {
        markerId: id
        title
        description
        markIn
        markOut
      }
    }
  }
`;

export default updateMarker;
